import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary";
import { initSentry } from "./lib/sentry";
import { initAnalytics } from "./lib/analytics";
import { setupBilling } from "./lib/googlePlayBilling";
// Guided-tour library base styles (Group E). MUST be imported BEFORE
// index.css so our brand overrides win on equal-specificity selectors.
// Driver.js v1.4 sets `.driver-popover { background-color:#fff; color:#2d2d2d }`
// at the wrapper level — if its sheet imports after ours, the white
// background wins and our `.sportsbio-tour-popover .driver-popover-title`
// styles (which set color to hsl(var(--foreground)), a near-white tone
// in dark mode) end up white-on-white = invisible popovers. The fix
// is purely import order; CSS specificity does the rest.
import "driver.js/dist/driver.css";
import "./index.css";

// Init telemetry first so anything thrown during App boot is captured.
initSentry();
initAnalytics();
// Initialise Google Play Billing (RevenueCat). No-op on web/iOS or when
// the plugin/API key is absent, so it's safe to fire unconditionally.
void setupBilling();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
